import React, {useId} from "react"
import {Area, AreaChart, ResponsiveContainer} from "recharts"

export type ChartDataPoint = {
  uv: number
}

export type BoardChartProps = {
  data?: ChartDataPoint[]
  className?: string
  color?: string
  strokeWidth?: number
}

export const BoardChart: React.FC<BoardChartProps> = ({data = [], className, color = "#E92323", strokeWidth = 0.7}) => {
  const uniqueId = useId()
  const gradientId = `gradient-${uniqueId}`

  return (
    <ResponsiveContainer width={"100%"} height={"100%"} className={className}>
      <AreaChart data={data} margin={{top: 0, right: 0, left: 0, bottom: 0}}>
        <defs>
          <linearGradient id={gradientId} x1={"0"} y1={"0"} x2={"0"} y2={"1"}>
            <stop offset={"30%"} stopColor={color} stopOpacity={0.85} />
            <stop offset={"90%"} stopColor={color} stopOpacity={0.0} />
          </linearGradient>
        </defs>
        <Area
          type={"bump"}
          dataKey={"uv"}
          stroke={color}
          strokeWidth={strokeWidth}
          fill={`url(#${gradientId})`}
          activeDot={false}
        />
      </AreaChart>
    </ResponsiveContainer>
  )
}
